import { DiscoveryTooltip, IconButton } from '@bloobirds-it/flamingo-ui';
import React from 'react';
import styles from './meetingForm.modules.css';
import { UserHelperKeys } from '../../constants/userHelperKeys';
import { useUserHelpers } from '../../hooks/useUserHelpers';
// @ts-ignore
import CalendarImage from '../../../assets/calendarDiscovery.png';

export const MeetingDiscoveryTooltip = ({
  defaultTooltipVisible,
}: {
  defaultTooltipVisible: boolean;
}) => {
  const { save } = useUserHelpers();
  return (
    <span className={styles.discovery_tooltip}>
      <DiscoveryTooltip
        title="New meeting scheduling experience"
        anchor={
          !defaultTooltipVisible && <IconButton name="infoFilled" color="darkBloobirds" size={16} />
        }
        visible={defaultTooltipVisible}
      >
        <DiscoveryTooltip.TooltipImage className={styles.image}>
          <img src={CalendarImage} width={230} alt={'calendar'} />
        </DiscoveryTooltip.TooltipImage>
        <DiscoveryTooltip.TooltipFooter
          description="Preview your colleagues' calendars, preview calendars in other timezones,
            create the event directly in your calendar... and much more!"
        >
          <DiscoveryTooltip.TooltipButton
            variant="clear"
            color="white"
            size="small"
            onClick={() => window.open('https://www.youtube.com/watch?v=XL9CtV0ePeo', '_blank')}
            className={styles.clear_button}
          >
            Know More
          </DiscoveryTooltip.TooltipButton>
          <DiscoveryTooltip.TooltipButton
            variant="secondary"
            isMainButton={true}
            size="small"
            onClick={() => save(UserHelperKeys.NEW_MEETING_MODAL)}
          >
            Ok
          </DiscoveryTooltip.TooltipButton>
        </DiscoveryTooltip.TooltipFooter>
      </DiscoveryTooltip>
    </span>
  );
};
